import Config from './src/config.js';

export default { Config };